import React from 'react'
import Header from '../../components/Header' 
import Footer from '../../components/Footer'
import Info3 from './components/Info3'
import Info4 from './components/info4'
import Info5 from './components/info5'
import Info6 from './components/info6'
import './style.css'
import FloatingWhatsAppButton from '../../components/FloatingWhatsAppButton'
import Info7 from './components/info7'
export default function Home() {
  return (
    <div className='homediv' style={{ width: '100vw'}}>
      <FloatingWhatsAppButton />
      <Header /> 
      <Info3 />
      <Info4 />
      {/* <Info6 />
      <Info5 />
      <Info7 /> */}
      <Footer />
    </div>
  )
}
